<template>

  <v-container grid-list-xl fluid>
    <v-layout row wrap >
      <v-flex sm12>
        <div class="col-md-12" style="float: right;">
          <v-dialog v-model="modalday.dialog" persistent max-width="50%">
            <v-btn color="primary" dark slot="activator">Desativar Dia</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Desativando data</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                      label="Data"
                      type="date"
                      v-model="day"
                      required autofocus></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="modalday.dialog = false">Fechar</v-btn>
                <v-btn color="blue darken-1" flat @click="updateDay()">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-flex>
    </v-layout>
  </v-container>    

</template>

<script>
import {http, httpLogin} from '../../backend/vue-axios/axios';
import swal from 'sweetalert';
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      day: '',
      modalday: {
        dialog: false
      },          
    };
  },

  mounted () {

  }, 

  methods: {

    updateDay() {
      http.post('disabled_day', {
        date: this.day,
      })
      .then(response => {
        console.log(response)
        this.modalday.dialog = false;
        swal({
          title: "Dia!",
          text: "inativado com sucesso!",
          icon: "success",
          timer: 1000,
          button: false

        });
      })
    },
  }
};
</script>
<style scoped lang="css">

</style>



// WEBPACK FOOTER //
// src/components/agendamentos/Day.vue